export default __webpack_public_path__ + "static/media/gs.d27e585b.svg";